import { c as _c } from "react/compiler-runtime";
import React from 'react';
import MobileOnly from 'components/consumer/MobileOnly';
import MobileModal from 'components/consumer/MobileModal';
import CtaButton from 'components/essentials/Cta/CtaButton';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import WidthRangeFilter from 'components/consumer/consumer-search/advanced-search-next/components/WidthRangeFilter';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';
import MobileProductFilters from './MobileProductFilters';
import MobileProductListingColorFilter from './MobileProductListingColorFilter';
import ProductClearAllFiltersButton from './ProductClearAllFiltersButton';
const MobileProductFiltersModal = t0 => {
  const $ = _c(28);
  const {
    isOpen,
    onClose,
    productsCount,
    items,
    refine,
    canClear,
    clearRefinement,
    colorFilters,
    refineColorFilters
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.filter(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeFilterCount = t1.length;
  const {
    isReadyToShipActive,
    handleToggleReadyToShip
  } = useAdvancedSearchContext();
  let t2;
  if ($[2] !== canClear || $[3] !== clearRefinement) {
    t2 = <ProductClearAllFiltersButton canClear={canClear} clearRefinement={clearRefinement} />;
    $[2] = canClear;
    $[3] = clearRefinement;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = productsCount || 0;
  const t4 = productsCount === 1 ? "" : "s";
  let t5;
  if ($[5] !== onClose || $[6] !== t3 || $[7] !== t4) {
    t5 = <CtaButton block={true} onClick={onClose}>Done ({t3} result{t4})</CtaButton>;
    $[5] = onClose;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = activeFilterCount > 0 ? `Filters (${activeFilterCount})` : "Filters";
  let t7;
  if ($[9] !== handleToggleReadyToShip || $[10] !== isReadyToShipActive) {
    t7 = <div className="mb-4"><QuickShipFilter isChecked={isReadyToShipActive} onChange={handleToggleReadyToShip} minHeight={false} withLocation={true} showLabelOnMobile={true} /></div>;
    $[9] = handleToggleReadyToShip;
    $[10] = isReadyToShipActive;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mb-4"><WidthRangeFilter showTitle={true} /></div>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== colorFilters || $[14] !== refineColorFilters) {
    t9 = <div className="mb-4"><MobileProductListingColorFilter colorFilters={colorFilters} refineColorFilters={refineColorFilters} /></div>;
    $[13] = colorFilters;
    $[14] = refineColorFilters;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== items || $[17] !== refine) {
    t10 = <MobileProductFilters items={items} refine={refine} />;
    $[16] = items;
    $[17] = refine;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== isOpen || $[20] !== onClose || $[21] !== t10 || $[22] !== t2 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t9) {
    t11 = <MobileOnly><div className="md:hidden"><MobileModal enableHashHistory={false} headerRight={t2} isFullHeight={true} isOpen={isOpen} onClose={onClose} stickyFooter={t5} title={t6}>{t7}{t8}{t9}{t10}</MobileModal></div></MobileOnly>;
    $[19] = isOpen;
    $[20] = onClose;
    $[21] = t10;
    $[22] = t2;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};
export default MobileProductFiltersModal;
function _temp(item) {
  return item.isRefined;
}